/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  ra: {
    ...dutchMessages.ra,
    action: {
      ...dutchMessages.ra?.action,
      disable: 'Uitschakelen',
      enable: 'Inschakelen',
    },
    navigation: {
      ...dutchMessages.ra?.navigation,
      no_filtered_results: 'Geen %{resource} gevonden met de huidige filters.',
      clear_filters: 'Filters wissen',
    },
  },
  submenu: {
    beheer: 'Beheer',
    monitoring: 'Monitoring',
  },
  menu: {
    costExplorer: 'Kostenoverzicht',
    applications: 'Applicaties',
    mcpServers: 'MCP Servers',
    proxies: 'Proxies',
    organizations: 'Organisaties',
    automation: 'Automatisering',
    alerts: 'Alerts',
    auditLog: 'Auditlogboek',
    accessRequests: 'Toegangsaanvragen',
    platformRequests: 'Platformaanvragen',
    requests: 'Aanvragen',
    workflows: 'Workflows',
  },
  dashboard: {
    title: 'Dashboard',
    loading: 'Dashboard laden...',
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
    },
    description: 'Welkom bij xxllnc.ai.',
    statistics: 'statistieken',
    sectionPlatform: 'Platform',
    sectionTraffic: 'Verkeer',
    totalServers: 'MCP Servers',
    totalProxies: 'Proxies',
    totalOrganizations: 'Organisaties',
    totalUsers: 'Gebruikers',
    mcpLinks: 'MCP koppelingen',
    proxyLinks: 'Proxy koppelingen',
    activeUsers: 'Actieve gebruikers',
    totalCalls: 'totaal calls',
    mcpToday: 'MCP vandaag',
    mcpWeek: 'MCP deze week',
    proxyToday: 'Proxy vandaag',
    proxyWeek: 'Proxy deze week',
    requestsToday: 'Vandaag',
    requestsThisWeek: 'Deze week',
    errorRate: 'Foutpercentage',
    avgResponseTime: 'Responstijd',
    sectionOverall: 'Totaal',
    activeAlerts: 'Actieve alerts',
    pendingAccessRequests: '%{count} openstaande toegangsaanvra(a)g(en) wachten op beoordeling',
    pendingPlatformRequests: '%{count} openstaande platformaanvra(a)g(en) wachten op beoordeling',
    review: 'Beoordelen',
    topMcpOrganizations: 'Top organisaties MCP (30 dagen)',
    topProxyOrganizations: 'Top organisaties Proxy (30 dagen)',
    activeSeats: 'Actieve seats',
    topUsageOrgs: 'Top gebruik organisaties (30 dagen)',
    activeWorkflows: 'Actieve workflows',
    recentExecutions: 'Uitvoeringen (24u)',
    totalExecutions: 'totaal uitvoeringen',
    popularMcps: 'Populairste MCPs',
    organizations: 'organisaties',
    calls: 'calls',
    noData: 'Geen data beschikbaar',
    live: {
      lastHour: 'Laatste uur',
      now: 'Nu',
      last24h: 'Laatste 24 uur',
      calls: 'Calls',
      executions: 'Workflow-runs',
      activeUsers: 'Actieve gebruikers',
      errorRate: 'Foutpercentage',
      errors: 'Fouten',
      trafficTitle: 'Verkeer',
      durationsTitle: 'Workflow-duur',
      avg: 'gem.',
      noRuns: 'Geen runs in deze periode',
      workflow: 'Workflow',
      runs: 'Runs',
      errorsCol: 'Fouten',
      mcpErrorsTitle: 'MCP-servers met fouten (recent)',
      workflowErrorsTitle: 'Workflows met fouten (recent)',
      weeklyArchive: 'Verkeer per week',
    },
    capacity: {
      title: 'Capaciteit',
      mcp: 'MCP-verkeer',
      workflows: 'Workflows',
      healthy: 'Comfortabel',
      busy: 'Druk',
      atLimit: 'Aan limiet',
      noPeak: 'geen recente piek',
      noDataTooltip: 'Nog geen recente data om capaciteit te schatten.',
      headerTooltip:
        'Geschatte platform­belasting over de laatste 7 dagen. Capaciteit berekend op ' +
        '%{pods} pods en een gemiddelde workflow­duur van %{seconds} seconden.',
      mcpTooltip:
        'Piek per uur: %{peak} requests (%{peakAt}). Gemiddeld %{avg} per uur. ' +
        'Capaciteit: %{ceiling} per uur. Bij hogere belasting kan het platform extra pods inzetten.',
      workflowTooltip:
        'Piek per uur: %{peak} uitvoeringen (%{peakAt}). Gemiddeld %{avg} per uur. ' +
        'Capaciteit: %{ceiling} per uur op %{pods} pods met een gemiddelde duur van %{seconds}s.',
    },
  },
  resources: {
    example: {
      list: 'Examples',
      create: 'Example aanmaken',
      show: 'Example',
    },
    application: {
      list: 'Applicaties',
      create: 'Applicatie aanmaken',
      show: 'Applicatie',
      edit: 'Applicatie bewerken',
      tabs: {
        environments: 'Omgevingen',
        headers: 'Headers',
      },
    },
    application_environment: {
      name: 'Omgeving',
    },
    mcp_server: {
      name: 'MCP Server |||| MCP Servers',
      list: 'MCP Servers',
      create: 'MCP Server aanmaken',
      show: 'MCP Server',
      edit: 'MCP Server bewerken',
      tabs: {
        details: 'Details',
        tools: 'Tools',
        links: 'Koppelingen',
        logs: 'Logs',
        skills: 'Skills',
      },
    },
    proxy: {
      list: 'Proxies',
      create: 'Proxy aanmaken',
      show: 'Proxy',
      edit: 'Proxy bewerken',
      tabs: {
        setup: 'Setup',
        details: 'Details',
        tools: 'Tools',
        links: 'Koppelingen',
        logs: 'Logs',
      },
    },
    mcp_tool: {
      create: 'Tool aanmaken',
      edit: 'Tool bewerken',
    },
    proxy_tool: {
      create: 'Tool aanmaken',
      edit: 'Tool bewerken',
    },
    organization: {
      list: 'Organisaties',
      create: 'Organisatie aanmaken',
      show: 'Organisatie',
      edit: 'Organisatie bewerken',
      tabs: {
        details: 'Details',
        users: 'Gebruikers',
        links: 'Koppelingen',
        mcpLinks: 'MCP Koppelingen',
        proxyLinks: 'Proxy Koppelingen',
        workflowLinks: 'Workflow koppelingen',
        usage: 'Usage',
        automations: 'Automations',
        chatConfig: 'Chat Config',
        identityProviders: 'Identity Providers',
        logs: 'Logs',
      },
      idp: {
        title: 'SSO Koppelingen',
        add: 'SSO toevoegen',
        addTitle: 'Identity Provider toevoegen',
        added: 'Identity provider toegevoegd',
        addFailed: 'Kon de identity provider niet toevoegen. Controleer de gegevens en probeer opnieuw.',
        loadFailed: 'Kon SSO koppelingen niet laden. De identity provider is mogelijk niet bereikbaar.',
        providerType: 'Type provider',
        alias: 'Alias',
        displayName: 'Weergavenaam',
        empty: 'Geen SSO koppelingen geconfigureerd.',
        notProvisioned: 'Deze organisatie is nog niet aangemaakt in de identity provider. Synchroniseer eerst de organisaties.',
      },
    },
    organization_user: {
      create: 'Gebruiker aanmaken',
      edit: 'Gebruiker bewerken',
    },
    organization_mcp_link: {
      create: 'MCP Koppeling aanmaken',
      edit: 'MCP Koppeling bewerken',
    },
    organization_proxy_link: {
      create: 'Proxy Koppeling aanmaken',
      edit: 'Proxy Koppeling bewerken',
    },
    organization_workflow_link: {
      create: 'Workflow koppeling toevoegen',
      edit: 'Workflow koppeling bewerken',
      linkLabel: '%{org} → %{workflow}',
      costPerWorkflowExecution: 'Kosten per uitvoering (EUR, override)',
      costPerWorkflowExecutionHelp:
        'Override de vergoeding per uitvoering voor deze organisatie en workflow. '
        + 'Laat leeg om de workflow- of portal-standaard over te nemen.',
      variablesTitle: 'Variabel-waarden',
      variablesSubtitle:
        'Waarden die deze organisatie meegeeft voor de variabelen die de workflow gebruikt via '
        + '{{ variables.X }}. Laat leeg om bij uitvoering geen waarde door te geven.',
      variablesEmpty:
        'Deze workflow gebruikt geen variabelen. '
        + 'Variabelen verschijnen hier zodra een node-parameter naar {{ variables.<naam> }} verwijst.',
      variableHelper: 'Waarde voor deze organisatie',
      serverConfigsTitle: 'Server-configuratie',
      serverConfigsSubtitle:
        'Per benodigde MCP server: welke omgeving, doel-URL en seat deze organisatie gebruikt '
        + 'bij uitvoering van de workflow.',
      serverConfigsEmpty:
        'Deze workflow heeft geen MCP-tool stappen die per-organisatie configuratie nodig hebben.',
      environment: 'Omgeving',
      environmentNone: 'Server-standaard gebruiken',
      baseUrl: 'Doel-URL',
      seat: 'Seat (identiteit)',
      seatNone: 'Aanroeper-identiteit gebruiken',
      seatHelper:
        'Geplande (cron) runs draaien als deze seat, omdat er geen triggerende gebruiker is. '
        + 'Handmatige runs draaien als de gebruiker die ze start en MCP-runs geven de aanroeper '
        + 'door — laat in die gevallen leeg.',
    },
    automation_rule: {
      list: 'Automation regels',
      create: 'Regel aanmaken',
      show: 'Automation regel',
      edit: 'Regel bewerken',
    },
    monitoring_rule: {
      name: 'Regel',
      tabs: {
        details: 'Details',
        alerts: 'Alerts',
      },
    },
    monitoring_alert: {
      list: 'Alerts',
      show: 'Alert',
    },
    documentUploads: {
      list: 'Document uploads',
      show: 'Document upload',
      upload: {
        button: 'Document uploaden',
        title: 'Document uploaden',
        success: 'Document upload aangemaakt',
      },
      tabs: {
        details: 'Details',
        logs: 'Logs',
      },
    },
  },
  auditLog: {
    timestamp: 'Tijdstip',
    action: 'Actie',
    actor: 'Gebruiker',
    actorUserId: 'Gebruikers-ID',
    targetType: 'Doeltype',
    targetId: 'Doel-ID',
    context: 'Details',
    createdAfter: 'Vanaf',
    createdBefore: 'Tot',
  },
  data: {
    costThisMonth: 'Kosten deze maand',
    usage: 'Verbruik',
    seats: 'Seats',
    mcpCostThisMonth: 'MCP kosten',
    proxyCostThisMonth: 'Proxy kosten',
    callsThisMonth: 'Calls deze maand',
    monthlyCosts: 'Maandelijkse kosten',
    currentMonth: 'Huidig',
    noCostData: 'Geen kostendata beschikbaar.',
    details: 'Details',
    name: 'Naam',
    description: 'Omschrijving',
    createdAt: 'Aangemaakt op',
    lastModified: 'Laatst gewijzigd',
    displayName: 'Naam',
    baseUrl: 'Base URL',
    baseUrlHelp: 'Laat leeg om de standaard URL van de server te gebruiken.',
    authType: 'Authenticatie type',
    headerName: 'Header naam',
    headerValue: 'Header waarde',
    headerType: 'Type',
    headerSource: 'Bron',
    headerPrefix: 'Prefix',
    headerPrefixHelp: 'Wordt voor de waarde geplakt, bijv. "employee:"',
    headerCustomValue: 'Waarde',
    headerCreated: 'Header aangemaakt',
    headerUpdated: 'Header bijgewerkt',
    customHeadersOptional: 'Custom HTTP headers (optioneel)',
    customHeadersDescription: 'Custom HTTP headers die meegezonden worden bij requests naar deze applicatie.',
    costPer1000Calls: 'Kosten per 1000 calls (€)',
    valueTypeCustom: 'Custom',
    valueTypeOrganization: 'Organisatie',
    valueTypeUser: 'Gebruiker',
    orgMetadataHelp: 'org.name, org.auth_id, of org.metadata.<key>',
    headerValueSource: 'Waarde / Bron',
    addHeader: 'Toevoegen',
    editHeader: 'Header bewerken',
    addHeaderTitle: 'Header toevoegen',
    noHeaders: 'Geen headers geconfigureerd.',
    deleteHeaderConfirm: 'Weet je zeker dat je deze header wilt verwijderen?',
    headerEnvironments: 'Omgevingen',
    headerEnvironmentsHelp: 'Selecteer voor welke omgevingen deze header geldt. Laat leeg voor alle.',
    tokenParamsDescription: 'Extra parameters die meegezonden worden in de OAuth token request body.',
    addTokenParam: 'Toevoegen',
    addTokenParamTitle: 'Token parameter toevoegen',
    editTokenParam: 'Token parameter bewerken',
    noTokenParams: 'Geen token parameters geconfigureerd.',
    deleteTokenParamConfirm: 'Weet je zeker dat je deze token parameter wilt verwijderen?',
    tokenParamCreated: 'Token parameter aangemaakt',
    tokenParamUpdated: 'Token parameter bijgewerkt',
    tokenParamName: 'Parameter naam',
    allEnvironments: 'Alle',
    userInterface: 'User interface',
    token: 'Token',
    enabled: 'Actief',
    serverId: 'Server ID',
    httpMethod: 'HTTP Methode',
    path: 'Pad',
    parameters: 'Parameters',
    paramName: 'Parameter naam',
    paramType: 'Type',
    required: 'Verplicht',
    user: 'Gebruiker',
    noUser: 'Geen gebruiker',
    username: 'Gebruikersnaam',
    auth0Email: 'Auth0 e-mailadres',
    organizationId: 'Organisatie ID',
    mcpServer: 'MCP Server',
    userAccess: 'Gebruikerstoegang',
    connectUrl: 'Connect URL',
    users: 'Gebruikers',
    selectUser: 'Selecteer gebruiker',
    grantAccess: 'Activeren',
    revokeAccess: 'Intrekken',
    seatUsersEmpty: 'Geen seats gevonden in deze organisatie',
    colUser: 'Gebruiker',
    colAccess: 'Toegang',
    toolSource: 'Tool bron',
    toolSourceManual: 'Handmatig',
    toolSourceOpenapi: 'OpenAPI Sync',
    toolSourceOdata: 'OData Sync',
    odataUrl: 'OData Metadata URL',
    odataUrlHelp: 'URL naar het $metadata endpoint (bijv. https://api.example.com/odata/$metadata)',
    openapiUrl: 'OpenAPI JSON URL',
    openapiUrlHelp: 'URL naar het OpenAPI JSON spec bestand',
    openapiSource: 'OpenAPI bron',
    specUrl: 'Spec URL',
    specInputUrl: 'URL',
    specInputFile: 'Bestand uploaden',
    selectSpecFile: 'Selecteer spec bestand',
    uploadSpecFile: 'Nieuw spec bestand uploaden',
    syncTools: 'Synchroniseren',
    syncFailed: 'Synchronisatie mislukt',
    copied: 'Gekopieerd',
    copy: 'Kopieer',
    copyUrl: 'Kopieer URL',
    organization: 'Organisatie',
    toolName: 'Tool',
    success: 'Succes',
    proxy: 'Proxy',
    targetUrl: 'Target URL',
    searchLogs: 'Zoek in logs...',
    searchTools: 'Zoek in tools...',
    copyFailed: 'Kopiëren mislukt. Kopieer handmatig.',
    enableAll: 'Alles aan',
    disableAll: 'Alles uit',
    proxyId: 'Proxy ID',
    auth0OrgId: 'Auth0 Organisatie ID',
    searchAuth0User: 'Zoek Auth0 gebruiker...',
    searchAuth0Org: 'Zoek Auth0 organisatie...',
    typeToSearch: 'Typ om te zoeken...',
    noResults: 'Geen resultaten',
    application: 'Applicatie',
    applicationType: 'Applicatie',
    noApplicationType: 'Geen applicatie',
    interface: 'Interface',
    certificate: 'Certificaat',
    downloadCert: 'Download certificaat',
    downloadKey: 'Download private key',
    generateCert: 'Genereer certificaat',
    regenerateCert: 'Vernieuw certificaat',
    ruleType: 'Type',
    logSource: 'Bron',
    aggregation: 'Aggregatie',
    operator: 'Operator',
    threshold: 'Drempel',
    windowMinutes: 'Tijdvenster (minuten)',
    cooldownMinutes: 'Cooldown (minuten)',
    lastTriggered: 'Laatst getriggerd',
    severity: 'Ernst',
    acknowledged: 'Bevestigd',
    condition: 'Conditie',
    actions: 'Acties',
    ruleTypeCustom: 'Custom',
    ruleTypeFairUse: 'Fair Use',
    logSourceAll: 'Alles',
    logSourceMcp: 'MCP',
    logSourceProxy: 'Proxy',
    allOrganizations: 'Alle organisaties',
    acknowledge: 'Bevestigen',
    title: 'Titel',
    status: 'Status',
    statusAvailable: 'Beschikbaar',
    statusInactive: 'Inactief',
    blockedUntil: 'Geblokkeerd tot %{date}',
    mcpCalls: 'MCP calls',
    proxyCalls: 'Proxy calls',
    workflowExecutions: 'Workflow uitvoeringen',
    statMcpServers: 'MCP Servers',
    statProxies: 'Proxies',
    statHeaders: 'Headers',
    statTools: 'Tools',
    statLinks: 'Links',
    statSkills: 'Skills',
    statusExpired: 'Vervallen',
    statusDownloaded: 'Gedownload',
    singleUse: 'Eenmalig',
    downloaded: 'Gedownload',
    expiresAt: 'Vervalt op',
    created: 'Aangemaakt',
    createdBy: 'Aangemaakt door',
    visibility: 'Zichtbaarheid',
    visibilityPersonal: 'Persoonlijk',
    visibilityShared: 'Gedeeld',
    authTypeNone: 'Geen',
    authTypeOauthClientCredentials: 'OAuth client credentials',
    authTypeClientCertificate: 'Client certificaat',
    authTypeCustomHeaders: 'Custom Headers',
    authTypePassword: 'Wachtwoord',
    authTypeAuth0: 'Auth0',
    auth0User: 'Auth0 gebruiker',
    password: 'Wachtwoord',
    expiration: 'Vervaltijd',
    expiration1Day: '1 dag',
    expiration7Days: '7 dagen',
    expiration30Days: '30 dagen',
    expirationNever: 'Nooit',
    selectFiles: 'Bestanden selecteren',
    files: 'Bestanden',
    downloadLogs: 'Download logs',
    downloaderIdentity: 'Downloader',
    errorMessage: 'Foutmelding',
    ipAddress: 'IP adres',
    addSource: 'API Bron toevoegen',
    addSourceName: 'Naam',
    addSourceType: 'Type',
    addSourceSpecUrl: 'Spec URL',
    addSourceSpecUrlHelp: 'URL naar de OpenAPI JSON/YAML of OData $metadata',
    addSourceSubmit: 'Toevoegen',
    addSourceSuccess: 'API bron toegevoegd en gesynchroniseerd',
    sourceDeleted: 'API bron verwijderd',
    syncResult: 'Sync: %{created} nieuw, %{updated} bijgewerkt, %{disabled} uitgeschakeld',
    manualTools: 'Handmatige tools',
    noToolsFound: 'Geen tools gevonden',
    noTools: 'Geen tools',
    hideDisabled: '%{count} uitgeschakeld',
    modified: 'Aangepast',
    deleteSource: 'Verwijder',
    other: 'Overig',
    logLevel: 'Logniveau',
    testFailed: 'Test mislukt',
    sync: 'Sync',
    orgSyncResult:
      'Sync voltooid: %{created} aangemaakt, %{updated} bijgewerkt, ' +
      '%{deleted} verwijderd, %{reactivated} geheractiveerd',
    metadataFields: 'Custom metadata velden',
    metadataKey: 'Sleutel',
    metadataValue: 'Waarde',
    deletedBanner: 'Deze organisatie is verwijderd uit Auth0. Er kunnen geen nieuwe koppelingen of gebruikers worden toegevoegd.',
    marketplaceVisible: 'Vindbaar in marketplace',
    mcpUrlSlug: 'URL slug',
    mcpUrlSlugHelp: 'Het URL-pad voor deze MCP (bijv. /mcp/mijn_server). Wijzigen verbreekt bestaande verbindingen.',
    mcpAbout: 'Over deze MCP (portal)',
    projectInstructions: 'Project instructies (CLAUDE.md / GEMINI.md)',
    projectInstructionsHelp: 'Instructies die gebruikers kopiëren naar hun project configuratie',
    advancedSettings: 'Geavanceerde instellingen',
    isDemo: 'Demo MCP',
    isDemoHelp:
      'Demo MCPs kunnen zonder goedkeuring in de portal worden geactiveerd en automatisch gekoppeld aan nieuwe free-tier organisaties.',
    defaultBaseUrl: 'Default target URL',
    defaultBaseUrlHelp: 'Wordt gebruikt als base URL bij het aanmaken van koppelingen. Verplicht voor Demo MCPs.',
    defaultEnvironment: 'Standaard omgeving',
    defaultEnvironmentHelp: 'Omgeving die wordt gebruikt bij automatisch goedkeuren. Verplicht als automatisch goedkeuren aan staat.',
    autoApproveAccess: 'Toegangsverzoeken automatisch goedkeuren',
    skillLinked: 'Skill gekoppeld',
    skillUnlinked: 'Skill ontkoppeld',
    skillUpdated: 'Skill bijgewerkt',
    skillCreatedLinked: 'Skill aangemaakt en gekoppeld',
    skillEdit: 'Bewerken',
    skillUnlink: 'Ontkoppelen',
    skillLinkExisting: 'Bestaande skill koppelen',
    skillAdd: 'Toevoegen',
    skillNew: 'Nieuwe skill',
    skillsShared: 'Skills worden gedeeld tussen MCP servers. Wijzigingen aan een skill gelden overal waar deze gekoppeld is.',
    skillsEmpty: 'Nog geen skills gekoppeld. Koppel een bestaande skill of maak een nieuwe aan.',
    skillsAllLinked: 'Alle skills zijn al gekoppeld aan deze server.',
    skillsAllLinkedForApp: 'Alle skills voor deze applicatie zijn gekoppeld. Verwijder het filter om andere skills te zien.',
    skillFilterAllApps: 'Alle applicaties',
    skillLinkedTo: 'Gekoppeld aan %{count} servers',
    skillDialogEdit: 'Skill bewerken',
    skillDialogNew: 'Nieuwe skill',
    skillApplication: 'Applicatie',
    skillNoApplication: 'Geen applicatie (globaal)',
    skillName: 'Naam',
    skillDescription: 'Beschrijving (optioneel)',
    skillContent: 'Content',
    skillCancel: 'Annuleren',
    skillSave: 'Opslaan',
    skillCreate: 'Aanmaken',
    skillClose: 'Sluiten',
    skillCustom: 'Aangepast',
    tokenUrl: 'Token URL',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    audience: 'Audience',
    certificatePem: 'Clientcertificaat (PEM)',
    certificatePemHelp: 'PEM-gecodeerd clientcertificaat',
    privateKeyPem: 'Privésleutel (PEM)',
    privateKeyPemHelp: 'PEM-gecodeerde privésleutel (onversleuteld)',
    environment: 'Omgeving',
    environments: 'Omgevingen',
    addEnvironment: 'Omgeving toevoegen',
    editEnvironment: 'Omgeving bewerken',
    deleteEnvironmentConfirm: 'Weet je zeker dat je deze omgeving wilt verwijderen?',
    noEnvironments: 'Geen omgevingen geconfigureerd.',
    environmentAuthHelp: 'Auth credentials worden per omgeving geconfigureerd.',
    environmentCreated: 'Omgeving aangemaakt',
    environmentUpdated: 'Omgeving bijgewerkt',
    envStatusActive: 'Actief',
    envStatusDisabled: 'Uitgeschakeld',
    noEnvironmentsHint: 'Voeg een omgeving toe om authenticatie credentials te configureren.',
    identitySection: 'Identiteit',
    authenticationSection: 'Authenticatie',
    toolEdit: 'Tool bewerken',
    toolUpdated: 'Tool bijgewerkt',
    toolSaveFailed: 'Opslaan mislukt',
    toolEnabled: 'Ingeschakeld',
    toolDisabled: 'Uitgeschakeld',
    toolParameters: 'Parameters',
    toolParameter: 'Parameter',
    toolEnum: 'Enum:',
    workflows: 'Workflows',
    mcpHealth: 'MCP Gezondheid',
    healthy: 'Gezond',
    warning: 'Waarschuwing',
    error: 'Fout',
    noRecentWorkflows: 'Geen recente workflow uitvoeringen',
    noMcpLinks: 'Geen MCP koppelingen',
    downloadUrl: 'Download URL',
    severityCritical: 'Kritiek',
    severityWarning: 'Waarschuwing',
    severityInfo: 'Info',
    workflow: 'Workflow',
    triggeredBy: 'Getriggerd door',
    triggerType: 'Trigger type',
  },
  costExplorer: {
    title: 'Kostenoverzicht',
    totalCosts: 'Totale kosten',
    seatCosts: 'Seat kosten',
    mcpSlotCosts: 'MCP slot kosten',
    workflowSlotCosts: 'Workflow slot kosten',
    workflowExecutionCosts: 'Workflow uitvoeringskosten',
    platformCosts: 'Platform kosten',
    chatCosts: 'Chat kosten',
    periodCurrentMonth: 'Deze maand',
    period3m: '3 maanden',
    period6m: '6 maanden',
    period12m: '12 maanden',
    periodAll: 'Alle tijd',
    organization: 'Organisatie',
    allOrganizations: 'Alle organisaties',
    costTimeline: 'Kosten tijdlijn',
    organizationBreakdown: 'Organisatie overzicht',
    seats: 'Seats',
    mcpSlots: 'MCP slots',
    workflowSlots: 'Workflow slots',
    total: 'Totaal',
    calls: 'Calls',
    cost: 'Kosten',
    serverBreakdown: 'Kosten per MCP server',
    proxyBreakdown: 'Kosten per proxy',
    workflowBreakdown: 'Kosten per workflow',
    workflow: 'Workflow',
    proxy: 'Proxy',
    executions: 'Uitvoeringen',
    executionCost: 'Uitvoeringskosten',
    aiTokens: 'AI-tokens',
    aiCostEstimated: 'AI-kosten (schatting)',
    avgPerDay: 'Gem. per dag',
    vsLastPeriod: 'vs vorige periode',
  },
  settings: {
    title: 'Instellingen',
    description: 'Beheer je persoonlijke voorkeuren',
    saved: 'Instellingen opgeslagen',
    organization: 'Organisatie',
    organizationName: 'Naam',
    organizationAuthId: 'Organisatie ID',
    section: {
      language: 'Taal',
      appearance: 'Weergave',
      about: 'Over',
    },
    languageTitle: 'Taal',
    languageDescription: 'Kies de taal voor de interface',
    appearanceTitle: 'Weergave',
    appearanceDescription: 'Pas het uiterlijk van de applicatie aan',
    filtersOpen: 'Filters standaard open',
    filtersOpenHelp: 'Toon het filterpaneel automatisch op lijstpagina\'s',
    rowsPerPage: 'Rijen per pagina',
    aboutTitle: 'Over deze applicatie',
    userName: 'Naam',
    userEmail: 'E-mail',
    appVersion: 'Versie',
  },
  login: {
    title: 'Beheer',
    button: 'Verder',
    email: 'naam@werk-email.com',
    emailLabel: 'E-mail adres',
    emailHint: 'Login om verder te gaan.',
    hint: 'Log in op xxllnc.ai',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'xxllnc.ai is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
    selectOrganization: 'Kies je organisatie',
    noOrganization: 'Geen organisatie gevonden voor dit e-maildomein.',
    back: 'Terug',
    loading: 'Organisaties opzoeken...',
    lookingFor: 'Op zoek naar de xxllnc.ai gebruikerslogin?',
    signInToHub: 'Login op xxllnc.ai voor je organisatie',
    changeRegion: 'Regio wijzigen',
    noAdminAccess: 'Geen admin toegang',
    noAdminAccessHint:
      'Je bent ingelogd, maar je account heeft geen toegang tot het admin dashboard. ' +
      'Log uit om een ander account te gebruiken, of ga naar de MCP Hub.',
    noAdminAccessAction: 'Uitloggen en ander account gebruiken',
  },
  proxySetup: {
    title: 'Proxy configuratie',
    intro: 'Gebruik onderstaande stappen om deze proxy te configureren voor API toegang.',
    step1Title: 'Proxy Base URL',
    step1Description:
      'Gebruik deze base URL gevolgd door het pad van de target API. ' +
      'Authenticeer met een client certificaat (mTLS). Download het certificaat en de private key bij de organisatiekoppeling.',
    step2Title: 'Test de verbinding',
    step2Description:
      'Gebruik onderstaand curl commando om de proxy te testen. Vervang ' +
      '{pad-naar-api} door het gewenste API pad. Gebruik het client certificaat en private key van de organisatiekoppeling.',
    curlComment: '# Test de proxy verbinding met client certificaat',
  },
  usageChart: {
    daily: 'Per dag',
    monthly: 'Per maand',
    noData: 'Geen usage data beschikbaar',
    loadError: 'Fout bij het laden van usage data',
  },
  logsChart: {
    total: 'Totaal',
    errors: 'Fouten',
    period24h: '24 uur',
    period7d: '7 dagen',
    period30d: '30 dagen',
  },
  delete: {
    confirmTitle: 'Verwijderen bevestigen',
    confirmContentMcp: 'Weet je zeker dat je deze MCP server wilt verwijderen? ' +
      'Alle gekoppelde organisatie-koppelingen, gebruikerstoegang en logs worden ook verwijderd.',
    confirmContentProxy: 'Weet je zeker dat je deze proxy wilt verwijderen? ' +
      'Alle gekoppelde organisatie-koppelingen, gebruikerstoegang en logs worden ook verwijderd.',
    confirmContentOrganization: 'Weet je zeker dat je deze organisatie wilt verwijderen? ' +
      'Alle gebruikers, koppelingen en logs worden ook verwijderd.',
    confirmContentDocument: 'Weet je zeker dat je deze document upload wilt verwijderen? ' +
      'Alle bestanden en download logs worden ook verwijderd.',
    confirmContentUser: 'Weet je zeker dat je deze gebruiker wilt verwijderen?',
    confirmContentMcpLink: 'Weet je zeker dat je deze MCP koppeling wilt verwijderen? ' +
      'Alle gebruikerstoegang wordt ook verwijderd.',
    confirmContentProxyLink: 'Weet je zeker dat je deze proxy koppeling wilt verwijderen?',
    confirmContentMonitoringRule:
      'Weet je zeker dat je deze monitoring regel wilt verwijderen? ' +
      'Alle bijbehorende alerts worden ook verwijderd.',
    confirmContentWorkflow:
      'Weet je zeker dat je deze workflow wilt verwijderen? Alle gekoppelde ' +
      'organisatie-verbindingen en uitvoeringen worden ook verwijderd.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
    noPermissions: {
      title: 'Geen rechten toegewezen',
      text:
        'Je account heeft toegang tot het dashboard maar nog geen specifieke '
        + 'rechten. Vraag een platform-admin om de sa.* rollen (of de '
        + 'admin_full composite) toe te wijzen die je nodig hebt.',
    },
  },
  orgMembers: {
    noAuth0Org: 'Deze organisatie heeft geen Auth0 org gekoppeld.',
    noMembers: 'Geen leden gevonden in Auth0 voor deze organisatie.',
    name: 'Naam',
    email: 'E-mail',
    roles: 'Rollen',
    seat: 'Seat',
    chat: 'Chat',
    seatYes: 'Actief',
    seatNo: 'Geen seat',
    chatOn: 'Aan',
    chatOff: 'Uit',
    beheerder: 'Beheerder',
    assignSeat: 'Seat toewijzen',
    removeSeat: 'Seat verwijderen',
    makeBeheerder: 'Maak beheerder',
    removeBeheerder: 'Verwijder beheerder',
    seatAssigned: 'Seat succesvol toegewezen',
    seatRemoved: 'Seat succesvol verwijderd',
    beheerderAssigned: 'Beheerderrol succesvol toegewezen',
    beheerderRemoved: 'Beheerderrol succesvol verwijderd',
    installInChat: 'Installeren in Chat',
    removeFromChat: 'Verwijderen uit Chat',
    chatInstalled: 'Gebruiker succesvol geinstalleerd in Chat',
    chatRemoved: 'Gebruiker succesvol verwijderd uit Chat',
    actionFailed: 'Actie mislukt. Probeer het opnieuw.',
  },
  portalBranding: {
    title: 'Styling',
    menuTitle: 'Styling',
    description: 'Configureer de styling van de portalen. Kleuren, logo en titels worden getoond aan alle gebruikers.',
    noConfig: 'Nog geen branding configuratie. Sla op om aan te maken.',
    saved: 'Instellingen opgeslagen',
    section: {
      colors: 'Kleuren',
      header: 'Header',
      typography: 'Typografie & Vorm',
      secureAccessBranding: 'xxllnc.ai branding',
      mcpHubBranding: 'MCP Hub branding',
    },
    primaryColor: 'Primaire kleur',
    primaryColorHelp: 'Hoofdkleur voor knoppen en accenten, bijv. #28282C',
    secondaryColor: 'Secundaire kleur',
    secondaryColorHelp: 'Accentkleur, bijv. #E86E44',
    loginBgColor: 'Login achtergrondkleur',
    loginBgColorHelp: 'Achtergrond van de inlogpagina',
    bgColor: 'Paginaachtergrond',
    bgColorHelp: 'Achtergrond van het portaal (standaard: #fafafa)',
    headerColor: 'Header achtergrondkleur',
    headerColorHelp: 'Standaard: wit',
    headerTextColor: 'Header tekstkleur',
    headerTextColorHelp: 'Gebruik lichte kleur (#ffffff) voor donkere headers',
    fontFamily: 'Lettertype',
    fontFamilyHelp: 'Google Fonts naam, bijv. Inter of Roboto. Leeg = DM Sans',
    borderRadius: 'Hoekafronding (0\u201320)',
    borderRadiusHelp: '0 = scherp/zakelijk, 10 = standaard, 20 = afgerond',
    adminTitle: 'Beheerportaal titel',
    adminTitleHelp: 'Titel getoond in de header van het xxllnc.ai beheerportaal',
    portalTitle: 'Portaaltitel',
    portalTitleHelp: 'Bijv. MCP Hub',
    loginSubtitle: 'Inlogpagina ondertitel',
    loginSubtitleHelp: 'Korte welkomsttekst op de inlogpagina (max 200 tekens)',
    logoUrl: 'Logo',
    logoUrlHelp: 'URL naar het logo (afbeelding)',
    faviconUrl: 'Favicon',
    faviconUrlHelp: 'URL naar het favicon',
    uploadImage: 'Afbeelding uploaden',
    changeImage: 'Afbeelding wijzigen',
    enabled: 'Custom branding actief',
  },
  portalSettings: {
    title: 'Portaal Instellingen',
    menuTitle: 'Portaal Instellingen',
    description: 'Configureer platforminstellingen, tier limieten, features en portal branding.',
    saved: 'Instellingen opgeslagen',
    section: {
      branding: 'Branding',
      tiers: 'Tier Limieten',
      features: 'Features',
      defaults: 'Kosten Standaarden',
      chat: 'Chat',
      importExport: 'Import / Export',
    },
    chat: {
      description:
        'Schakel individuele chatmodellen in of uit. Ingeschakelde modellen zijn '
        + 'bruikbaar voor elke chatgebruiker; uitgeschakelde modellen zijn alleen voor beheerders.',
      enabled: 'Ingeschakeld',
      disabled: 'Uitgeschakeld',
      enabledCount: '{count} van {total} modellen ingeschakeld',
      loadFailed: 'Modellen laden mislukt.',
      updateFailed: 'Model bijwerken mislukt. Probeer het opnieuw.',
      retry: 'Opnieuw',
      empty: 'Er zijn nog geen chatmodellen beschikbaar.',
    },
    branding: {
      description: 'Configureer de styling van het MCP Hub portaal. Kleuren, logo en titels worden getoond aan alle portaalgebruikers.',
    },
    importExport: {
      description: 'Bundel en migreer platformconfiguratie. Gevoelige gegevens worden nooit meegenomen.',
      export: {
        title: 'Configuratie exporteren',
        description: 'Maak een overdraagbare JSON-bundel van applicaties, MCP-servers en workflows.',
        button: 'Configuratie exporteren…',
        modalTitle: 'Configuratie exporteren',
        modalIntro: 'Kies wat je wilt meenemen. Afhankelijkheden worden automatisch toegevoegd '
          + '— een MCP-server neemt zijn applicatie mee, een workflow neemt zijn servers en applicaties mee.',
        applications: 'Applicaties',
        mcpServers: 'MCP-servers',
        workflows: 'Workflows',
        modeNone: 'Geen',
        modeAll: 'Alle',
        modeSelected: 'Kies…',
        includeDependencies: 'Afhankelijkheden automatisch meenemen',
        downloadButton: 'Bundel downloaden',
        cancel: 'Annuleren',
        emptySelection: 'Selecteer minstens één onderdeel om te exporteren.',
      },
      import: {
        title: 'Configuratie importeren',
        description: 'Pas een eerder geëxporteerde bundel toe op deze omgeving.',
        dropzone: 'Sleep een .json-bundel hier of klik om te bladeren',
        dropzoneActive: 'Loslaten om bundel te laden',
        invalidFile: 'Alleen .json-bundels worden ondersteund.',
        previewTitle: 'Import controleren',
        previewIntro: 'Controleer wat wordt aangemaakt, bijgewerkt of overgeslagen voordat je toepast.',
        sectionApplications: 'Applicaties',
        sectionSkills: 'Vaardigheden',
        sectionMcpServers: 'MCP-servers',
        sectionWorkflows: 'Workflows',
        chipNew: 'Nieuw',
        chipExists: 'Bestaat',
        toggleAll: 'Alle aan/uit',
        decisionCreate: 'Aanmaken',
        decisionSkip: 'Overslaan',
        decisionOverwrite: 'Overschrijven',
        dependsOn: 'Vereist %{names}',
        warningHeader: 'Waarschuwingen',
        executeButton: 'Importeren (%{count})',
        cancel: 'Annuleren',
        successCounts: '%{created} aangemaakt · %{updated} bijgewerkt · %{skipped} overgeslagen · %{failed} mislukt',
        emptyBundle: 'Deze bundel bevat geen items.',
        previewing: 'Bundel inlezen…',
      },
      lastImport: {
        title: 'Laatste import',
        description: 'Meest recente import op deze omgeving.',
        emptyState: 'Er is nog geen import vastgelegd.',
        by: 'door %{actor}',
        bundle: 'Bundel: %{filename}',
        statCreated: 'aangemaakt',
        statUpdated: 'bijgewerkt',
        statSkipped: 'overgeslagen',
        statFailed: 'mislukt',
      },
    },
    tiers: {
      description: 'Configureer MCP slots en seat limieten per tier. Deze limieten gelden platformbreed.',
      mcpSlots: 'MCP slots',
      seatMax: 'Max seats',
      approval: 'Goedkeuring',
      autoApprove: 'Free tier automatisch goedkeuren voor nieuwe organisaties',
    },
    features: {
      description: 'Schakel platformfeatures in of uit.',
      chatEnabled: 'Chat (Open WebUI) ingeschakeld',
      authTitle: 'Authenticatie',
      beheerderRole: 'Beheerderrol',
      beheerderRoleHelp: 'Selecteer de Keycloak realm rol die portaalbeheerders identificeert.',
      selectScope: 'Selecteer de vereiste scope voor beheerdertoegang:',
    },
    defaults: {
      description: 'Standaard kostenwaarden voor nieuwe organisaties. Kunnen per organisatie worden overschreven.',
      costPerSeat: 'Kosten per seat',
      costPerMcp: 'Kosten per MCP slot',
      costPerWorkflow: 'Kosten per workflow slot',
      costPerWorkflowExecution: 'Kosten per workflow-uitvoering',
      costPerWorkflowExecutionHelp:
        'Wordt in rekening gebracht voor elke workflow-run als noch de workflow zelf, '
        + 'noch een organisatie-workflow-koppeling een eigen tarief heeft.',
      aiQuotaEurPerHour: 'AI-uurlimiet',
      aiQuotaEurPerHourHelp:
        'Harde uurlimiet op AI-uitgaven binnen workflows wanneer een organisatie geen eigen override heeft.',
      platformBudget: 'Platform budget',
      workflowBudget: 'Workflow budget',
      chatBudget: 'Chat budget',
    },
    litellm: {
      title: 'LiteLLM spend-import',
      description:
        'Eén management-LiteLLM-API-key waarmee elke ~10 minuten de AI-kosten van alle '
        + 'organisaties worden opgehaald. Elke org wordt gematcht op zijn opgeslagen LiteLLM-key-id.',
      status: 'Status:',
      configured: 'Geconfigureerd',
      notConfigured: 'Niet geconfigureerd',
      keyLabel: 'Management API-key',
      keyHelp:
        'Plak een management-key om deze in te stellen of te vervangen. Laat leeg om de '
        + 'huidige key te behouden.',
    },
    capacity: {
      title: 'Platform capaciteit',
      description:
        'Plafonds die de capaciteits­widget en de automatische alert­regels gebruiken. ' +
        'Pas aan als je extra pods inzet of de gemiddelde workflow­duur wijzigt.',
      mcpHourCeiling: 'MCP-capaciteit per uur',
      mcpHourCeilingHelp:
        'Maximaal aantal MCP-requests per uur bij volle cache-hit en huidige pod-configuratie.',
      workflowPods: 'Aantal pods',
      workflowPodsHelp:
        'Aantal actieve secureaccess-api pods (Helm maxReplicas). Bepaalt samen met de gemiddelde duur de workflow-capaciteit.',
      avgWorkflowSeconds: 'Gemiddelde workflow-duur (seconden)',
      avgWorkflowSecondsHelp:
        'Verwachte gemiddelde duur per workflow-uitvoering. Capaciteit = pods × 50 slots × 3600 ÷ duur.',
      alertThresholdPct: 'Alert-drempel (%)',
      alertThresholdPctHelp:
        'Stuurt een melding zodra de piekbelasting dit percentage van de capaciteit overschrijdt.',
    },
  },
  platformRequest: {
    filters: {
      status: 'Status',
      tier: 'Tier',
    },
    status: {
      pending: 'In behandeling',
      approved: 'Goedgekeurd',
      denied: 'Afgewezen',
    },
    tier: {
      free: 'Free',
      team: 'Team',
      enterprise: 'Enterprise',
    },
    fields: {
      organization: 'Organisatie',
      tier: 'Tier',
      requester: 'Aanvrager',
      status: 'Status',
      date: 'Datum',
      actions: 'Acties',
    },
    approve: 'Goedkeuren',
    deny: 'Afwijzen',
    denyDialog: {
      title: 'Aanvraag afwijzen',
      reason: 'Reden',
      cancel: 'Annuleren',
    },
  },
  automationRule: {
    scope: 'Scope',
    scopeGlobal: 'Alle organisaties',
    scopeSpecific: 'Specifieke organisaties',
    tiers: 'Tiers',
    organizations: 'Organisaties',
    triggers: 'Triggers',
    actions: 'Acties',
    loading: 'Laden...',
    tabs: {
      details: 'Details',
      alerts: 'Alerts',
    },
    test: 'Test',
    titleCreate: 'Nieuwe automatisering',
    titleEdit: 'Automatisering bewerken',
    created: 'Regel aangemaakt',
    updated: 'Regel bijgewerkt',
    saveFailed: 'Opslaan mislukt',
    tierFilter: 'Tier filter',
    validation: {
      nameRequired: 'Naam is verplicht',
      triggerRequired: 'Voeg minimaal 1 trigger toe',
      actionRequired: 'Voeg minimaal 1 actie toe',
    },
    flow: {
      when: 'WANNEER',
      then: 'DAN',
      done: 'KLAAR',
      addTrigger: 'Trigger toevoegen',
      addAction: 'Actie toevoegen',
      triggerChip: 'TRIGGER',
      actionChip: 'ACTIE',
    },
    settings: {
      label: 'INSTELLINGEN',
      subtitle: 'Scope, cooldown & status',
      cooldownHelp: 'Minimale tijd tussen twee activeringen (0 = geen limiet)',
    },
    picker: {
      configuration: 'Configuratie',
      addToFlow: 'Toevoegen aan flow',
      triggerHint: 'Wanneer moet deze regel activeren?',
      actionHint: 'Wat moet er gebeuren?',
    },
  },
  accessRequest: {
    search: 'Zoeken',
    status: {
      pending: 'In behandeling',
      approved: 'Goedgekeurd',
      denied: 'Afgewezen',
    },
    requestType: {
      organization: 'Organisatie',
      user: 'Gebruiker',
    },
    fields: {
      requester: 'Aanvrager',
      mcpServer: 'MCP Server',
      organization: 'Organisatie',
      type: 'Type',
      environment: 'Omgeving',
      status: 'Status',
      date: 'Datum',
      actions: 'Acties',
      environmentUrl: 'Omgeving URL',
      environmentName: 'Omgeving',
      message: 'Bericht',
    },
    approve: 'Goedkeuren',
    createLink: 'Maak koppeling',
    deny: 'Afwijzen',
    denyDialog: {
      title: 'Aanvraag afwijzen',
      reason: 'Reden',
      cancel: 'Annuleren',
    },
    noExtraInfo: 'Geen extra informatie bij deze aanvraag.',
  },
  openwebuiConfig: {
    sectionLitellm: 'LiteLLM',
    sectionLitellmHelp: 'LLM-gateway: API key en key-gegevens waarmee chatverkeer wordt gerouteerd.',
    sectionOpenwebui: 'Open WebUI',
    sectionOpenwebuiHelp: 'De chatinterface: instance-URL en admin API key voor gebruikersbeheer.',
    litellmApiKey: 'LiteLLM API Key',
    litellmApiKeyHelp: 'Bijv. sk-zOUVjchU...',
    keyName: 'Key naam',
    keyNameHelp: 'Leesbare naam van de key in LiteLLM',
    keyId: 'Key ID',
    keyIdHelp: 'Interne key hash/ID uit LiteLLM',
    openwebuiUrl: 'Open WebUI URL',
    openwebuiUrlHelp: 'Publieke URL van de Open WebUI instance voor deze organisatie',
    openwebuiApiKey: 'Open WebUI API Key',
    openwebuiApiKeyHelp: 'Admin API key voor gebruikersbeheer in Open WebUI',
    enabled: 'Actief',
    enabledTierHelp: 'Alleen beschikbaar op de Enterprise (productie) tier.',
    tierWarning: 'Chat kan alleen worden geactiveerd voor organisaties met de Enterprise (productie) tier. '
      + 'Wijzig de tier naar Enterprise om chat in te schakelen.',
    descriptionExisting: 'Chat configuratie voor deze organisatie.',
    descriptionNew: 'Nog geen chat configuratie. Sla op om aan te maken.',
  },
  organizationCosts: {
    costPerSeat: 'Kosten per seat (EUR/maand)',
    costPerSeatHelp: 'Laat leeg voor standaard (EUR 15,00)',
    costPerMcp: 'Kosten per MCP (EUR/maand)',
    costPerMcpHelp: 'Laat leeg voor standaard (EUR 25,00)',
    costPerWorkflow: 'Kosten per workflow (EUR/maand)',
    costPerWorkflowHelp: 'Laat leeg voor portal-standaard',
    aiQuotaEurPerHour: 'AI-budget per uur (EUR)',
    aiQuotaEurPerHourHelp: 'Harde limiet op AI-uitgaven per uur voor deze organisatie. Laat leeg voor portal-standaard.',
  },
  logs: {
    time: 'Tijd',
    noLogs: 'Geen logs gevonden',
    statusOk: 'OK',
    statusError: 'Fout',
    bodyPreview: 'Response body preview',
    detailStatus: 'Status',
    detailUrl: 'URL',
    detailResponseTime: 'Response time',
    detailError: 'Error',
  },
  requests: {
    mcpRequest: 'MCP toegang',
    workflowRequest: 'Workflow',
    workflowGenerationRequest: 'AI-workflow',
    platformRequest: 'Platform',
    aiPrompt: 'Prompt',
    aiSummary: 'AI-samenvatting',
    openInGenerator: 'Open in generator',
    noRequests: 'Geen openstaande aanvragen',
    filterAll: 'Alle',
    filterPending: 'Openstaand',
    filterApproved: 'Goedgekeurd',
    filterDenied: 'Afgewezen',
    environmentUrl: 'Omgeving URL',
    reviewedBy: 'Beoordeeld door',
    reviewNote: 'Opmerking',
    requestedTier: 'Aangevraagd tier',
    description: {
      mcp: 'MCP: %{server}',
      platform: 'Tier upgrade: %{tier}',
    },
  },
  filters: {
    title: 'Filters',
    show: 'Filters tonen',
    status: 'Status',
    active: 'Actief',
    inactive: 'Inactief',
    deleted: 'Verwijderd',
    marketplace: 'Marketplace',
    marketplaceVisible: 'Zichtbaar',
    marketplaceHidden: 'Niet zichtbaar',
    toolSource: 'Tool bron',
    application: 'Applicatie',
    authType: 'Authenticatie type',
    tier: 'Tier',
    tierFree: 'Free',
    tierTeam: 'Team',
    tierEnterprise: 'Enterprise',
    tierNone: 'Geen',
    scope: 'Scope',
  },
  mcp: {
    list: {
      cost: 'Kosten / 1k calls',
      costPer1k: '/ 1k',
      links: 'Koppelingen',
      requests24h: 'Laatste 24u',
    },
  },
  workflow: {
    title: 'Workflow Editor',
    untitled: 'Naamloze Workflow',
    loading: 'Laden...',
    create: {
      nameDialogTitle: 'Geef je workflow een naam',
      nameLabel: 'Weergavenaam',
    },
    variables: {
      title: 'Variabelen',
      subtitle: 'Automatisch gedetecteerd uit {{ variables.X }} verwijzingen in je workflow-nodes.',
      emptyHelp: 'Nog geen variabelen — verwijs naar {{ variables.<naam> }} in een node-parameter en hij verschijnt hier.',
    },
    costPerWorkflowExecution: 'Kosten per uitvoering (EUR)',
    costPerWorkflowExecutionHelp: 'Override voor deze workflow. Laat leeg om de organisatie- of portal-standaard over te nemen.',
    sidebar: {
      search: 'Zoek nodes...',
      triggers: 'Triggers',
      mcpTools: 'MCP Tools',
      logic: 'Logica',
      data: 'Data',
      ai: 'AI',
    },
    nodes: {
      trigger: 'Trigger',
      toolCall: 'MCP Tool Call',
      aiCall: 'AI Aanroep',
      aiCallDesc: 'Roep een LLM model aan',
      condition: 'Conditie',
      loop: 'Loop',
      transform: 'Transformatie',
      fieldMapping: 'Veldmapping',
      fieldMappingDesc: 'Declaratieve veld-voor-veld mapping met transforms',
      merge: 'Samenvoegen',
      cron: 'Cron Schema',
      webhook: 'Webhook',
      manual: 'Handmatig',
      mcpTrigger: 'MCP Tool',
      cronDesc: 'Terugkerend schema',
      webhookDesc: 'HTTP callback',
      manualDesc: 'Handmatig starten',
      mcpTriggerDesc: 'Wordt aangeboden als MCP-tool voor AI-clients',
      conditionDesc: 'Als/anders vertakking',
      loopDesc: 'Herhaal over items',
      mergeDesc: 'Wacht op vertakkingen',
      transformDesc: 'Data mappen en transformeren',
      visualization: 'Visualisatie',
      visualizationDesc: 'Toon data als tabel of grafiek',
      data: 'Databron',
      dataDesc: 'Lees een fragment uit een link-attachment (XML/JSON)',
      parse: 'Parse',
      parseDesc: 'Voer een geregistreerde parser uit (bv. iNavigator → Zaken payload)',
      mcp: 'MCP Tool',
      dataStoreWrite: 'Data store: opslaan',
      dataStoreWriteDesc: 'Bewaar een waarde (vector of plain) onder een identifier voor latere lookup',
      dataStoreRead: 'Data store: lezen',
      dataStoreReadDesc: 'Lees een waarde terug uit de data store (semantisch of op key)',
      dataStoreUpdate: 'Data store: wijzigen',
      dataStoreUpdateDesc: 'Vervang inhoud + metadata van een bestaand vector-record op id',
      dataStoreDelete: 'Data store: verwijderen',
      dataStoreDeleteDesc: 'Verwijder een vector-record op id (idempotent)',
      dataStore: 'Data store',
      // eslint-disable-next-line max-len
      dataStoreDesc: 'Lezen, schrijven, wijzigen of verwijderen in de semantische data store (kies de operatie in de node-config).',
      tested: 'Getest',
    },
    config: {
      title: 'Node Configuratie',
      fm: {
        inputSource: 'Bron',
        inputSourceHelp: 'Pad zoals "nodes.data-1" of "trigger" — de dict om uit te mappen.',
        mappings: 'Mappings',
        addMapping: 'Mapping toevoegen',
        noMappings: 'Nog geen mappings — voeg er één toe om velden te extraheren.',
        from: 'Van',
        to: 'Naar',
        transform: 'Transform',
        required: 'Verplicht',
        maxLength: 'Max lengte',
        defaultValue: 'Standaardwaarde',
        lookupTable: 'Lookup tabel (JSON)',
        lookupTableHelp: 'Map bron-waarden naar doel-waarden, bv. {"Jaar":"year","Maand":"month"}.',
        regexPattern: 'Regex patroon',
        regexReplacement: 'Vervanging',
        transformNone: 'Geen transform',
        transformUppercase: 'HOOFDLETTERS',
        transformLowercase: 'kleine letters',
        transformTrim: 'Witruimte strippen',
        transformTruncate: 'Afkappen',
        transformDefault: 'Standaard bij leeg',
        transformLookup: 'Lookup tabel',
        transformToNumber: 'Naar getal',
        transformToBoolean: 'Naar boolean',
        transformRegexReplace: 'Regex vervangen',
      },
      label: 'Label',
      server: 'MCP Server',
      tool: 'Tool',
      parameters: 'Parameters',
      expression: 'Expressie',
      assertTruthy: 'Stop de workflow als deze conditie onwaar is',
      assertTruthyHelp:
        'Wanneer ingeschakeld, stopt een onwaar resultaat de workflow en wordt '
        + 'de onderstaande foutmelding teruggegeven aan de MCP-aanroeper.',
      assertError: 'Foutmelding',
      assertErrorPlaceholder: 'Bijv. Geen persoon gevonden met deze naam',
      cronExpression: 'Cron expressie',
      webhookPath: 'Webhook pad',
      attachmentRole: 'Attachment role',
      attachmentRoleHelp: 'Unieke naam zoals source_xml',
      attachmentRoleRequired: 'Deze data-node werkt pas als er een attachment role is ingevuld.',
      attachmentLabel: 'Attachment label',
      attachmentLabelHelp: 'Wat de klant ziet bij het uploaden, bv. i-Navigator DSP-export',
      attachmentDescription: 'Attachment description',
      attachmentDescriptionHelp: 'Optionele uitleg naast het upload-veld',
      attachmentFormatHint: 'Attachment format hint',
      attachmentFormatHintHelp: 'MIME of formaat-hint, bv. application/xml',
      format: 'Formaat',
      selector: 'Selector',
      selectorHelp: 'XPath (XML) of dotted path (JSON). Ondersteunt {{ expressies }}.',
      sourceExpression: 'Bron-expressie',
      // eslint-disable-next-line max-len
      sourceExpressionHelp: 'Wat er getoond wordt. Leeg laten voor de volledige output van de vorige node, of wijs een deel aan, bijv. {{ nodes.get-casetype.output.data }}.',
      // eslint-disable-next-line max-len
      mcpHelp: 'Workflows met een MCP trigger zijn beschikbaar als tools op /api/v1/mcp/workflows. Voeg deze URL toe als MCP server in Claude Desktop.',
      arrayExpression: 'Array expressie',
      itemVariable: 'Item variabele',
      loopLogChildren: 'Log elke body-node per iteratie',
      // eslint-disable-next-line max-len
      loopLogChildrenHelp: 'Wanneer aan, wordt elke node binnen de loop-body apart als execution-step bewaard. Standaard uit zodat een grote loop (bv. CSV-import) de steps-weergave niet overspoelt. Zet aan voor kleine gating-loops waar je volledige zichtbaarheid wilt.',
      trueLabel: 'Waar',
      falseLabel: 'Onwaar',
      perItem: 'Per item',
      mergeStrategy: 'Samenvoeg strategie',
      waitAll: 'Wacht op alle',
      firstResult: 'Eerste resultaat',
      deleteNode: 'Node verwijderen',
      fieldMapping: 'Veld mapping',
      paramJsonHelp: 'Verstuur deze parameter als JSON (object, array, boolean of getal) in plaats van tekst',
      paramJsonInvalid: 'Ongeldige JSON — de waarde wordt pas opgeslagen zodra deze geldig is',
      paramJsonFormat: 'JSON formatteren',
      paramNoDescription: 'Geen beschrijving — type: %{type}',
      paramSourceFixed: 'Vast',
      paramSourceExpression: 'Expressie',
      insertExpressionHelp: 'Voeg een expressie in — verwijs naar data van de trigger of vorige nodes',
      optionalFields: 'Optionele velden (%{smart_count})',
      // eslint-disable-next-line max-len
      paramsRemoved: '%{smart_count} parameter verwijderd — de gekozen tool ondersteunt deze niet. |||| %{smart_count} parameters verwijderd — de gekozen tool ondersteunt deze niet.',
      toolEmptyState: 'Kies een MCP server en een tool om deze stap te configureren.',
      toolDisabledSuffix: 'uitgeschakeld',
      // eslint-disable-next-line max-len
      toolDisabledWarning: 'De geselecteerde tool is uitgeschakeld op de MCP server. Schakel de tool in op de server of kies een andere — deze stap faalt zolang de tool uit staat.',
      // eslint-disable-next-line max-len
      inputDataEmpty: 'Nog geen input data bekend. Voer eerst een geslaagde test uit op een vorige node om de velden hier te zien.',
      inputDataHint: 'Klik op een veld om het in het laatst geselecteerde parameterveld in te voegen.',
      inputDataFromTrigger: 'trigger input',
      inputDataFromTest: 'uit testresultaat',
      inputDataFromAi: 'uit verwachte output',
      inputDataInserted: 'Ingevoegd',
      inputDataCopied: 'Gekopieerd — klik eerst een parameterveld aan om direct in te voegen',
      outputExample: 'Verwachte JSON output (voorbeeld)',
      // eslint-disable-next-line max-len
      outputExampleHint: 'Voorbeeld van het JSON-object dat de AI moet teruggeven. Wordt achter de prompt geplakt als structuurhint; de sleutels worden voor latere nodes beschikbaar als {{ nodes.<id>.output.veld }}.',
      paramsNotInSchema: 'Niet in tool-schema',
      paramsNotInSchemaHint: 'Staan op de node en gaan bij elke run mee, maar de tool kent ze niet. Bewerk of verwijder ze.',
      paramNotInSchemaType: 'opgeslagen',
      paramRemove: 'Parameter verwijderen',
      paramRequired: 'Verplichte parameter',
      testCall: 'Test aanroep',
      aiModel: 'Model',
      systemPrompt: 'Systeem prompt',
      systemPromptPlaceholder: 'Je bent een behulpzame assistent...',
      userPrompt: 'Gebruiker prompt',
      userPromptPlaceholder: 'Gebruik {{ expressies }} om data van vorige nodes te refereren',
      inputData: 'Input data',
      expectJson: 'Verwacht JSON output',
      temperature: 'Temperatuur',
      parser: 'Parser',
      parserPlaceholder: 'Kies een geregistreerde parser...',
      // eslint-disable-next-line max-len
      parserNoneEnabled: 'Geen parsers geactiveerd in deze deploy. Stel ENABLED_PARSERS in de API config in.',
      parserMode: 'Modus',
      parserModeParse: 'Parse',
      parserModeRequirements: 'Requirements (dry-run)',
      parserInputSource: 'Input source',
      // eslint-disable-next-line max-len
      parserInputSourceHelp: 'Pad-expressie die tegen context wordt opgelost. Verwijst meestal naar de upstream data-node, bv. {{ inavigator_xml.match }}.',
      parserExtra: 'Extra inputs',
      // eslint-disable-next-line max-len
      parserExtraHelp: 'Per call opgelost en aan de parser meegegeven. Gebruik dit om UUIDs uit eerdere tool_calls te injecteren (bv. catalog_folder_uuid).',
      parserExtraKeyPlaceholder: 'extra sleutel, bv. catalog_folder_uuid',
      mcpToolName: 'MCP tool naam',
      mcpToolNameHelp: 'Lowercase, snake_case. Hiermee roept Claude Desktop de tool aan.',
      mcpToolDescription: 'MCP tool beschrijving',
      // eslint-disable-next-line max-len
      mcpToolDescriptionPlaceholder: 'Wat doet deze tool? Wanneer moet de assistent hem gebruiken?',
      mcpToolDescriptionHelp: 'Wordt aan de assistent getoond in tools/list. Wees specifiek.',
      mcpToolInputSchema: 'Input schema',
      // eslint-disable-next-line max-len
      mcpToolInputSchemaHelp: 'JSON Schema dat de argumenten beschrijft die de tool accepteert. Gevalideerd bij blur.',
      mcpSchemaModeFields: 'Velden',
      mcpSchemaFieldName: 'naam',
      mcpSchemaFieldType: 'type',
      mcpSchemaNoFields: 'Nog geen velden — klik op "+ Veld toevoegen" om er een aan te maken.',
      mcpSchemaAddField: 'Veld toevoegen',
      mcpSchemaRequired: 'verplicht',
      mcpSchemaFieldDescription: 'Beschrijving (zichtbaar voor de aanroepende AI)',
      mcpSchemaMinLength: 'minLength',
      mcpSchemaMaxLength: 'maxLength',
      mcpSchemaFormat: 'format',
      mcpSchemaMin: 'min',
      mcpSchemaMax: 'max',
      mcpSchemaMinItems: 'minItems',
      mcpSchemaMaxItems: 'maxItems',
      mcpSchemaArrayItems: 'Schema van array-item',
      mcpSchemaJsonNotAnObject: 'Top-level schema moet een JSON-object zijn — kreeg een ander type.',
      mcpSchemaNameCollision: 'Er bestaat al een veld met deze naam.',
      mcpSchemaNameEmpty: 'Veldnaam mag niet leeg zijn.',
      dataStoreMode: 'Opslagmodus',
      dataStoreModeVector: 'Vector (semantisch)',
      dataStoreModePlain: 'Plain (key/value)',
      // eslint-disable-next-line max-len
      dataStoreModeVectorHelp: 'Slaat op in pgvector en embed de inhoud bij opslaan. Lezen geeft de meest gelijkende matches op betekenis.',
      // eslint-disable-next-line max-len
      dataStoreModePlainHelp: 'Slaat op in Redis als identifier+key → value. Geen embedding-kosten, exact-match lezen.',
      // eslint-disable-next-line max-len
      dataStoreReadVectorHelp: 'Semantisch zoeken over eerder opgeslagen inhoud. Trager; geeft beste matches op betekenis.',
      // eslint-disable-next-line max-len
      dataStoreReadPlainHelp: 'Exact lookup op key. Laat key leeg om alle entries onder de identifier terug te geven.',
      dataStoreIdentifier: 'Identifier',
      // eslint-disable-next-line max-len
      dataStoreIdentifierHelp: 'Collection-naam. Workflows met dezelfde identifier delen dezelfde data slice (per organisatie).',
      dataStoreKey: 'Key',
      dataStoreKeyHelp: 'Verplicht voor plain modus. Wordt de Redis hash-veldnaam.',
      dataStoreReadKeyHelp: 'Key om op te zoeken. Laat leeg om alle entries onder deze identifier te krijgen.',
      dataStoreKeyword: 'Zoekwoord-filter',
      // eslint-disable-next-line max-len
      dataStoreKeywordHelp: 'Optionele substring-match op content, key en metadata-waarden. Koppel aan een MCP-arg (bv. {{ trigger.keyword }}) zodat de assistent in de collectie kan zoeken.',
      // eslint-disable-next-line max-len
      csvHelp: 'CSV wordt geparsed naar een lijst rijen. Gebruik een Loop-node verderop (arrayExpression: nodes.<id>.rows) en verwijs naar kolommen via {{ item.<header> }}.',
      autocompleteFunctionsLoadFailed:
        'Lijst met functies kon niet geladen worden. Herlaad de editor — je sessie is mogelijk verlopen.',
      dataStoreOperation: 'Operatie',
      dataStoreOpRead: 'Lezen',
      dataStoreOpWrite: 'Opslaan',
      dataStoreOpUpdate: 'Wijzigen',
      dataStoreOpDelete: 'Verwijderen',
      dataStoreContent: 'Inhoud om op te slaan',
      dataStoreValue: 'Waarde om op te slaan',
      dataStoreRecordId: 'Record id',
      // eslint-disable-next-line max-len
      dataStoreRecordIdHelp: 'UUID van het record dat je wilt wijzigen of verwijderen. Meestal gekoppeld aan {{ trigger.id }} bij gebruik als MCP-tool.',
      // eslint-disable-next-line max-len
      dataStoreContentHelp: 'Vrije tekst of {{ nodes.x.output }} referentie. Wordt automatisch ge-embed bij opslaan.',
      // eslint-disable-next-line max-len
      dataStoreValueHelp: 'Vrije tekst of {{ nodes.x.output }} referentie. Wordt letterlijk in Redis opgeslagen.',
      dataStoreMetadata: 'Metadata (optioneel)',
      dataStoreMetadataHelp: 'Sleutel/waarde paren die bij het record bewaard worden. Waarden mogen upstream nodes referencen.',
      dataStoreQuery: 'Zoekvraag',
      // eslint-disable-next-line max-len
      dataStoreQueryHelp: 'Vraag in natuurlijke taal. De best matchende records (cosine similarity) komen terug in hits[].',
      dataStoreTopK: 'Aantal hits',
      dataStoreTopKHelp: 'Hoeveel records terug (1-50). Lager = sneller.',
    },
    node: {
      missingAttachmentRoleSubtitle: 'Attachment role ontbreekt',
      missingAttachmentRoleWarning: 'Configureer een attachment role voordat je deze workflow opslaat.',
      dataStoreMissingIdentifier: 'Identifier ontbreekt',
      dataStoreMissingContent: 'Inhoud ontbreekt',
      dataStoreMissingKey: 'Key ontbreekt',
      dataStoreMissingQuery: 'Zoekvraag ontbreekt',
      dataStoreMissingRecordId: 'Record id ontbreekt',
      dataStoreUpdateSummary: 'Wijzigt record',
      dataStoreDeleteSummary: 'Verwijdert record',
      dataStoreDeletePlainSummary: 'Verwijderen (plain) uit',
      dataStoreWriteVectorSummary: 'Opslaan (vector) in',
      dataStoreWritePlainSummary: 'Opslaan (plain) in',
      dataStoreReadVectorSummary: 'Zoeken (vector) in',
      dataStoreReadPlainSummary: 'Lezen (plain) uit',
      dataStoreReadAll: 'alle entries',
    },
    actions: {
      autoLayout: 'Auto layout',
      undo: 'Ongedaan maken',
      executions: 'Uitvoeringen',
      editFlow: 'Flow bewerken',
    },
    details: {
      name: 'Naam',
      about: 'Over',
      triggerType: 'Trigger type',
      nodeCount: 'Nodes',
      edgeCount: 'Edges',
      autoApprove: 'Automatisch goedkeuren',
    },
    list: {
      cost: 'Kosten / run',
      costPortalDefault: '(portal-standaard)',
      costNotSet: 'Niet ingesteld',
      links: 'Koppelingen',
      executions24h: 'Laatste 24u',
      triggerType: 'Trigger',
    },
    stat: {
      executions24h: 'Runs · laatste 24u',
      executionsTotal: 'Runs · totaal',
      executionsSuccessful: 'Geslaagde runs',
      executionsFailed: 'Gefaalde runs',
      links: 'Koppelingen',
      successRate: 'Slagingspercentage',
      successRateNoData: 'Slagingspercentage (geen data)',
      successRateTitle: 'Gezondheid',
    },
    filters: {
      trigger: 'Trigger',
      triggerManual: 'Handmatig',
      triggerCron: 'Cron',
      triggerWebhook: 'Webhook',
      triggerMcp: 'MCP tool',
    },
    tabs: {
      details: 'Details',
      links: 'Koppelingen',
      executions: 'Uitvoeringen',
      noExecutions: 'Nog geen uitvoeringen.',
    },
    test: {
      title: 'Test',
      organization: 'Organisatie',
      seat: 'Gebruiker (optioneel)',
      noSeat: 'Standaard (admin)',
      environment: 'Omgeving',
      defaultEnvironment: 'Standaard',
      execute: 'Uitvoeren',
      success: 'Gelukt',
      failed: 'Mislukt',
      availableFields: 'Beschikbare velden (klik om pad te kopieren)',
      copied: 'Gekopieerd!',
      orgHelp: 'Bepaalt met welke koppeling en data van welke organisatie de test draait.',
      // eslint-disable-next-line max-len
      seededFromExpression: 'In de workflow wordt dit gevuld door %{expression} — vul een concrete testwaarde in.',
      invalidJson: 'Ongeldige JSON',
      omitValue: 'Weglaten',
      errorAuth: 'Geen toegang — controleer de koppeling (authenticatie) van deze organisatie.',
      errorForbidden: 'Toegang geweigerd — deze gebruiker of koppeling mag deze actie niet uitvoeren.',
      errorNotFound: 'Niet gevonden — het object of endpoint bestaat niet in het doelsysteem.',
      errorValidation: 'De parameters kloppen niet met wat de tool verwacht — controleer verplichte velden en types.',
      errorUpstream: 'De achterliggende server gaf een fout — probeer opnieuw of controleer het doelsysteem.',
      errorNetwork: 'De achterliggende server is niet bereikbaar — controleer de base URL en verbinding.',
      errorDetails: 'Details',
    },
    execution: {
      workflow: 'Workflow',
      organization: 'Organisatie',
      status: 'Status',
      trigger: 'Trigger',
      triggeredBy: 'Gestart door',
      started: 'Gestart',
      finished: 'Voltooid',
      duration: 'Duur',
      stepsCount: 'Stappen',
      steps: 'Stappen',
      error: 'Fout',
      filterStatus: 'Status',
      completed: 'Voltooid',
      running: 'Actief',
      failed: 'Mislukt',
      pending: 'Wachtend',
      success: 'Geslaagd',
      skipped: 'Overgeslagen',
      deleteTitle: 'Uitvoering verwijderen?',
      deleteContent: 'Deze uitvoering en alle stappen worden permanent verwijderd.',
    },
    ai: {
      button: 'Genereer met AI',
      title: 'AI-workflowgenerator',
      intro:
        'Beschrijf wat je workflow moet doen — inclusief de trigger, de stappen en wat er met de uitkomst gebeurt.'
        + ' De assistent stelt vragen als iets onduidelijk is.',
      descriptionLabel: 'Beschrijf de workflow',
      descriptionPlaceholder:
        'Elke werkdag om 9:00 de openstaande Topdesk-tickets ophalen, samenvatten met een LLM'
        + ' en de samenvatting in #service-desk op Slack plaatsen.',
      submit: 'Doorgaan',
      analyzing: 'Beschrijving wordt geanalyseerd…',
      needsMoreInfo: 'Ik heb nog wat extra informatie nodig',
      answerLabel: 'Voeg de ontbrekende details toe',
      answerPlaceholder: 'Geef de ontbrekende informatie…',
      summaryTitle: 'Dit ga ik bouwen',
      summaryHint: 'Bevestig de beschrijving hieronder of pas hem aan voordat je bouwt.',
      build: 'Workflow bouwen',
      edit: 'Beschrijving aanpassen',
      building: 'Workflow wordt gebouwd…',
      successTitle: 'Workflow klaar',
      successMessage: 'Open de workflow om hem te bekijken en te verfijnen.',
      openWorkflow: 'Workflow openen',
      errorTitle: 'Er is iets misgegaan',
      errorBody: 'De assistent kon deze workflow niet genereren.',
      retry: 'Opnieuw proberen',
    },
    doctor: {
      title: 'AI Doctor',
      intro:
        'Deze run is mislukt. Laat AI de trace bekijken en een concrete oplossing voorstellen.',
      start: 'Diagnose starten',
      analyzing: 'AI analyseert de fout…',
      cached: '(uit cache)',
      explanation: 'Uitleg',
      suggestedFix: 'Voorgestelde oplossing',
      suggestedInputs: 'Voorgestelde input',
      rootCause: 'Oorzaak in node',
      refresh: 'Nieuwe diagnose',
      retryWithFix: 'Opnieuw proberen met fix',
      retryStarted: 'Nieuwe poging gestart.',
    },
    copilot: {
      title: 'AI Co-pilot',
      tagline: 'Pas deze workflow aan met AI',
      toggle: 'AI Co-pilot',
      intro:
        'Beschrijf wat je wil aanpassen. De Co-pilot stelt een wijziging voor die je eerst kunt bekijken.',
      try: 'Probeer een prompt',
      suggestRetry: 'Voeg een retry toe op de falende tool call',
      suggestSummary: 'Voeg een AI-stap toe die de vorige output samenvat',
      suggestParallel: 'Voer de twee tool calls parallel uit en merge het resultaat',
      placeholder: 'Beschrijf een wijziging…',
      send: 'Versturen',
      thinking: 'AI denkt na…',
      you: 'Jij',
      assistant: 'Co-pilot',
      pendingDiff: 'Voorgestelde wijziging',
      apply: 'Toepassen',
      discard: 'Verwerpen',
      diffAdd: 'Toevoegen',
      diffUpdate: 'Aanpassen',
      diffRemove: 'Verwijderen',
    },
    editor: {
      unsavedTitle: 'Niet-opgeslagen wijzigingen',
      // eslint-disable-next-line max-len
      unsavedBody: 'Je hebt niet-opgeslagen wijzigingen in deze workflow. Als je de pagina verlaat gaan ze verloren.',
      unsavedStay: 'Blijven bewerken',
      unsavedLeave: 'Verlaten zonder opslaan',
    },
    validation: {
      title: 'Deze workflow heeft problemen',
      description: 'Los de problemen hieronder op vóór het opslaan, of gebruik "Toch opslaan" als je weet wat je doet.',
      errorCount: '%{count} fout |||| %{count} fouten',
      warningCount: '%{count} waarschuwing |||| %{count} waarschuwingen',
      cancel: 'Problemen oplossen',
      saveAnyway: 'Toch opslaan',
      saveAnywayConfirm: 'Opslaan houdt de niet-opgeloste verwijzingen erin. Die worden tijdens uitvoering een lege string. Doorgaan?',
      jumpToNode: 'Spring naar node',
      registryUnavailable: 'Functienamen kunnen niet gecontroleerd worden — registry is niet beschikbaar.',
      unclosedBraces: 'Niet-gesloten expressie — voeg `}}` toe om `{{` af te sluiten.',
      emptyExpression: 'Lege expressie — schrijf iets tussen `{{` en `}}`.',
      emptySegment: 'Lege pad-segment — verwijder de extra punt.',
      unknownRoot: 'Onbekend root `%{root}` — gebruik `functions`, `variables`, `trigger` of `nodes`.',
      unknownFunction: 'Onbekende functie `functions.%{name}` — controleer de spelling.',
      malformedFunctionCall: 'Functieaanroep heeft haakjes nodig — schrijf `functions.<naam>(...)`.',
      unknownNode: 'Geen node met naam `%{id}` in deze workflow.',
      nodeNotReachable: 'Node `%{id}` is geen voorganger van deze node — wordt een lege string tijdens uitvoering.',
      unknownTriggerKey: 'Trigger heeft geen veld `%{key}`.',
      unknownVariable: 'Variabele `%{name}` wordt nog nergens anders gebruikt — wordt aangemaakt bij opslaan.',
    },
  },
}
